
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/work/generated/ui/shared/outcomes/content-view/jst/_criterionHeader.handlebars";
import "/work/generated/ui/shared/outcomes/content-view/jst/_criterion.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/outcomes/content-view/jst/outcomeForm';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, self=this, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <label>\n      <div style=\"display: flex\">\n        <div id='criterion_rating_label' style=\"margin-top: 0.65rem\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome_form.criterion", "Criterion ratings", options) : helperMissing.call(depth0, "t", "outcomes.outcome_form.criterion", "Criterion ratings", options)))
    + "</div>\n        <div id=\"react-info-link\"></div>\n      </div>\n    </label>\n    <table class=\"criterion\" aria-labelledby='criterion_rating_label'>\n      <thead>\n        <tr>\n          ";
  stack1 = (helper = helpers.eachWithIndex || (depth0 && depth0.eachWithIndex),options={hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.ratings), options) : helperMissing.call(depth0, "eachWithIndex", (depth0 && depth0.ratings), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          <th class=\"total\" aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "total_points_44d76792", "Total Points", options) : helperMissing.call(depth0, "t", "total_points_44d76792", "Total Points", options)))
    + "'>\n            <h5 class=\"total\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "total_points_44d76792", "Total Points", options) : helperMissing.call(depth0, "t", "total_points_44d76792", "Total Points", options)))
    + "</h5>\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          ";
  stack1 = (helper = helpers.eachWithIndex || (depth0 && depth0.eachWithIndex),options={hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.ratings), options) : helperMissing.call(depth0, "eachWithIndex", (depth0 && depth0.ratings), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        <td class=\"total\">\n          <div class=\"points_possible\">\n            ";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{
    'precision': (2),
    'strip_insignificant_zeros': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.points_possible), options) : helperMissing.call(depth0, "n", (depth0 && depth0.points_possible), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_points_possible_precision_2_st': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "n_points_possible_precision_2_st_points_bc3748df", "%{n_points_possible_precision_2_st} Points", options) : helperMissing.call(depth0, "t", "n_points_possible_precision_2_st_points_bc3748df", "%{n_points_possible_precision_2_st} Points", options)))
    + "\n          </div>\n        </td>\n        </tr>\n      </tbody>\n    </table>\n    <div class=\"learning_outcome__mastery_points_wrap\">\n      <label for=\"mastery_points\" class=\"learning_outcome__mastery_points__label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome_form.mastery", "Mastery at", options) : helperMissing.call(depth0, "t", "outcomes.outcome_form.mastery", "Mastery at", options)))
    + "* </label>\n      <span id=\"mastery_point_container\" data-initial-value=\""
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{
    'precision': (2),
    'strip_insignificant_zeros': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.mastery_points), options) : helperMissing.call(depth0, "n", (depth0 && depth0.mastery_points), options)))
    + "\"></span>\n    </div>\n    <div>\n      <label for=\"calculation_method\" style=\"display: inline\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome_form.calculation_method", "Calculation Method", options) : helperMissing.call(depth0, "t", "outcomes.outcome_form.calculation_method", "Calculation Method", options)))
    + "</label>\n      <select name=\"calculation_method\" class=\"calculation_method\" id=\"calculation_method\" data-calculation-method=\"";
  if (helper = helpers.calculation_method) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculation_method); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" value=\"";
  if (helper = helpers.calculation_method) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculation_method); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.calculationMethods), {hash:{},inverse:self.noop,fn:self.programWithDepth(6, program6, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </select>\n    </div>\n    <div class=\"content-box\">\n      <div class=\"grid-row\">\n        <!-- Hook for OutcomeCalculationMethodFormView -->\n        <div class=\"col-xs-12 outcome-calculation-method-form\"></div>\n      </div>\n    </div>\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            ";
  stack1 = self.invokePartial(partials['ui/shared/outcomes/content-view/jst/_criterionHeader.handlebars'], 'ui/shared/outcomes/content-view/jst/_criterionHeader.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            ";
  stack1 = self.invokePartial(partials['ui/shared/outcomes/content-view/jst/_criterion.handlebars'], 'ui/shared/outcomes/content-view/jst/_criterion.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  return buffer;
  }

function program6(depth0,data,depth1) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <option value=\""
    + escapeExpression(((stack1 = (data == null || data === false ? data : data.key)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" "
    + escapeExpression((helper = helpers.selectedIf || (depth1 && depth1.selectedIf),options={hash:{},data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.key), (depth1 && depth1.calculation_method), options) : helperMissing.call(depth0, "selectedIf", (data == null || data === false ? data : data.key), (depth1 && depth1.calculation_method), options)))
    + ">\n            ";
  if (helper = helpers.friendlyCalculationMethod) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.friendlyCalculationMethod); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n          </option>\n        ";
  return buffer;
  }

  buffer += "<form action=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"learning_outcome\" method=\"post\" novalidate>\n\n\n  <div class=\"span6 learning_outcome__margin-left-0\">\n    <label class=\"span3\" for=\"title\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome_form.title", "Name this outcome", options) : helperMissing.call(depth0, "t", "outcomes.outcome_form.title", "Name this outcome", options)))
    + " *</label>\n    <div id=\"title_container\" class=\"span3 learning_outcome__margin-left-0\" data-initial-value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></div>\n    <label class=\"span3\" for=\"display_name\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome_form.display_name", "Friendly name", options) : helperMissing.call(depth0, "t", "outcomes.outcome_form.display_name", "Friendly name", options)))
    + " </label>\n    <div id=\"display_name_container\" class=\"outcome_display_name span3 learning_outcome__margin-left-0\" data-initial-value=\"";
  if (helper = helpers.display_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.display_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></div>\n  </div>\n\n  <label for=\"description\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome_form.description", "Describe this outcome", options) : helperMissing.call(depth0, "t", "outcomes.outcome_form.description", "Describe this outcome", options)))
    + "</label>\n\n  <textarea cols=\"40\" name=\"description\" id=description rows=\"20\" style=\"display: none; width: 100%; height: 150px;\">";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</textarea>\n\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hideMasteryScale), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <div class=\"align-right\">\n    <button type=\"button\" class=\"btn cancel_button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("buttons"),
    'i18n_used_in': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "buttons.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "buttons.cancel", "Cancel", options)))
    + "</button>\n    <button type=\"submit\" class=\"btn btn-primary submit_button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("buttons"),
    'i18n_used_in': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "buttons.save", "Save", options) : helperMissing.call(depth0, "t", "buttons.save", "Save", options)))
    + "</button>\n  </div>\n</form>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  